import { useApi } from '@repo-level/core-front';
import { fetchConnectedAuthProviders } from 'api/auth';
import { useEffect } from 'react';

// Google is the only provider this brand enables, so any link means OAuth.
export const useIsProviderAccount = (isEnabled: boolean): boolean => {
  const [requestProviders, { data, error }] = useApi(
    fetchConnectedAuthProviders
  );

  useEffect(() => {
    if (!isEnabled) return;

    requestProviders();
  }, [isEnabled, requestProviders]);

  // An unanswered check must not keep the confirmation form from showing.
  if (!Array.isArray(data)) return !!error;

  return data.some((provider) => provider?.active);
};
